// extracted by mini-css-extract-plugin
export default {"underTitle":"GP7rdsIE97WzFlzLC6MJ"};